import { render, staticRenderFns } from "./ElTestimonial4.vue?vue&type=template&id=b5621172"
import script from "./ElTestimonial4.vue?vue&type=script&lang=js"
export * from "./ElTestimonial4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports